export default __webpack_public_path__ + "static/media/2.98c6412b.jpg";